import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Params, Router } from "@angular/router";
import { CorrectionHistory } from "src/app/mon-portefeuille/core/model/correction-history";
import { CorrectionHistoryService } from "src/app/mon-portefeuille/core/service/correction-history.service";

@Component({
  selector: "app-dossier-update",
  templateUrl: "./dossier-update.component.html",
  styleUrls: ["./dossier-update.component.scss"],
})
export class DossierUpdateComponent implements OnInit {
  requestId: string;
  correctionId: string;
  correctionHistory: CorrectionHistory;

  constructor(
    private _router: Router,
    private _activatedRoute: ActivatedRoute,
    private _correctionHistoryService: CorrectionHistoryService
  ) {}

  ngOnInit() {
    this.requestId = this._router.url.split("/")[3];
    this.correctionId = this._router.url.split("/")[4];
    this.getCorrectionHistoryById(this.correctionId);
  }

  getCorrectionHistoryById(correctionId) {
    this._correctionHistoryService
      .getCorrectionHistoryById(correctionId)
      .subscribe(
        (data) => {
          this.correctionHistory = data;
        },
        (error) => {
          console.log(error);
        }
      );
  }
}
